// extracted by mini-css-extract-plugin
module.exports = {"flag":"FormFieldActiveInLanguages_flag__2qRMI"};